export default "__VITE_ASSET__esyw6wAe__"